export const SORTING = {
	DIRECTIONS: {
		ASC: "ASC",
		DESC: "DESC"
	},
	DIRECTIONS_SIGN: {
		ASC: "",
		DESC: "-"
	},
	TYPES: {
		NUMBER: "number",
		STRING: "string",
		DATE: "date",
		BOOLEAN: "boolean",
		ANY: "any"
	}
};
